import React from "react";
import PrivateRoute from "./routes/PrivateRoute";
import Login from "./pages/auth/Login";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/dashboard/Dashboard";
import MainLayout from "./layouts/MainLayout";
import Profile from "./pages/profile/Profile";
import LotteryListPage from "./pages/lottery/LotteryListPage";
import Feedback from "./pages/ticket/Feedback";
import Ticket from "./pages/ticket/Ticket";
import LotteryDetail from "./pages/lottery/detail/LotteryDetail";
import MassMessage from "./pages/sms/MassMessage";
import Staff from "./pages/staff/Staff";
import News from "./pages/news/News";
import NewsDetail from "./pages/news/detail/NewsDetail";
import Bank from "./pages/bank/account/Bank";
import AccountStatement from "./pages/bank/statement/AccountStatement";
import CallCenter from "./pages/call-center/CallCenter";
import CallCenterDetail from "./pages/call-center/detail/CallCenterDetail";
import Reward from "./pages/reward/Reward";
import Grants from "./pages/reward/grants/Grants";
import Report from "./pages/report";

const App = () => {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />
      {/* Private */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        {/* --- DASHBOARD --- */}
        <Route path="dashboard" element={<Dashboard />} />
        {/* --- LOTTERY --- */}
        <Route
          path="lottery/active"
          element={<LotteryListPage type="active" />}
        />
        <Route
          path="lottery/completed"
          element={<LotteryListPage type="completed" />}
        />
        <Route
          path="lottery/draft"
          element={<LotteryListPage type="draft" />}
        />
        <Route path="lottery/:type/:id/edit" element={<LotteryDetail />} />
        {/* --- TICKET --- */}
        <Route path="ticket/engagement" element={<Ticket />} />
        <Route path="ticket/feedback" element={<Feedback />} />
        {/* --- REPORT --- */}
        <Route path="report" element={<Report />} />
        {/* --- PROFILE --- */}
        <Route path="profile" element={<Profile />} />
        {/* --- SMS --- */}
        <Route path="sms" element={<MassMessage />} />
        {/* --- STAFF --- */}
        <Route path="staff" element={<Staff />} />
        {/* --- BANK --- */}
        <Route path="bank/account" element={<Bank />} />
        <Route path="bank/statement" element={<AccountStatement />} />
        {/* --- NEWS --- */}
        <Route path="news" element={<News />} />
        <Route path="news/:id" element={<NewsDetail />} />
        {/* --- CALL CENTER --- */}
        <Route path="call-center" element={<CallCenter />} />
        <Route path="call-center/:id" element={<CallCenterDetail />} />
        {/* --- REWARD --- */}
        <Route path="reward" element={<Reward />} />
        <Route path="reward/:id" element={<Grants />} />
      </Route>
    </Routes>
  );
};

export default App;
